import { userColumnAdd, listHiddenColumn } from '../../api'
const topForm = {
    namespaced: true,
    state: {
        addColumnResp: null,
        hiddenColumnObj: null
    },
    mutations: {
        ADD_COLUMN_DATA(state, res) {
            state.addColumnResp = res;
        },
        HIDDEN_COLUMN_DATA(state, res) {
            state.hiddenColumnObj = res.obj || [];
        }
    },
    actions: {
        async userColumnAdd({ commit }, obj) {
            let res = await userColumnAdd(obj);
            commit('ADD_COLUMN_DATA', res)
        },
        async listHiddenColumn({ commit }, obj) {
            let res = await listHiddenColumn(obj);
            commit('HIDDEN_COLUMN_DATA', res)
        }
    }
}

export default topForm



// WEBPACK FOOTER //
// ./src/store/modules/topForm.js